import { inject, Injectable } from '@angular/core';
import { CompanyService } from './company.service';
import { storage } from '@utils/storage.service';
import { MfeUtilsService } from './MFE/mfe-utils.abstract.service';

@Injectable({
  providedIn: 'root'
})
export class SwitchTsModeService {
  private readonly mfeUtilsService = inject(MfeUtilsService);
  private readonly companyService = inject(CompanyService);
  readonly tsModeKey = 'tsMode';
  readonly mfeUrlKey = 'mfeUrl';
  showSwitcherToRecruiter = false;

  isTsModeActivated() {
    return !!storage.getItem(this.tsModeKey);
  }

  cleanTsFlag() {
    storage.removeItem(this.mfeUrlKey);
    storage.removeItem(this.tsModeKey);
  }

  switchTsMode() {
    if (this.isTsModeActivated()) {
      return;
    }

    const link = this.getTsModeLink();

    window.open(link, '_blank');
  }

  getTsModeLink() {
    let link = `https://${this.companyService.x1brdHost}/dashboard/#access_token=${storage.getItem('token')}&token_type=Bearer&expires_in=${storage.getItem('tokenTTL')}&tsMode=true`;
    if (this.mfeUtilsService.isMfe) {
      link += `&${this.mfeUrlKey}=${window.location.origin}/${this.mfeUtilsService?.appName}`;
    }

    return link;
  }

  switchRecruiterMode() {
    if (!this.isTsModeActivated()) {
      return;
    }

    const link = storage.getItem(this.mfeUrlKey) ?? `https://${this.companyService.x1brdHost}/dashboard`;
    this.cleanTsFlag();
    window.open(link, '_blank');
  }
}
